import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { selectPdlSearchData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import usePdlSearchV2 from './usePdlSearchV2'

const useRetrievePDLsV2 = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { errorMessage, podSearchDataId } = useSelector(selectPdlSearchData)

  const {
    getStreetNumberName,
    getZipCode,
    getInseeCode,
    getContractType,
    getOccupant,
    getMatricule,
    getComplement,
    getBuilding,
    getLocality,
    updateList,
    updatePdlConfigData,
  } = usePdlSearchV2()

  const searchPDLs = () => {
    const searchParams = {
      streetName: getStreetNumberName,
      zipcode: getZipCode,
      inseeCode: getInseeCode,
      contractType: getContractType,
      occupant: getOccupant,
      matricule: getMatricule,
      complement: getComplement,
      building: getBuilding,
      locality: getLocality,
    }

    const onSuccess = (results, searchId = null) => {
      updatePdlConfigData({ errorMessage: null })
      if (results?.length > 0) {
        updateList(results)
        updatePdlConfigData({ viewPage: 'results', isLoading: false })
      } else if (searchId) {
        updatePdlConfigData({ podSearchDataId: searchId })
      }
    }

    const onError = (error) => {
      console.error('❌ PDL Search error:', error)
      updatePdlConfigData({
        errorMessage: error || t('subscriptionTools:pdl_search.default_error_message'),
        isLoading: false,
        viewPage: 'results'
      })
    }

    updatePdlConfigData({ isLoading: true })
    updateList([])

    dispatch({
      type: subscriptionFormActionsV2.PDL_SEARCH_V2,
      searchParams,
      onSuccess,
      onError,
    })
  }

  useEffect(() => {
    if (podSearchDataId === null) {
      return
    }

    window.Echo.channel(`retrieve-search-pod-data.${podSearchDataId}`).listen('.retrieve-search-pod-data', e => {
      if (e.error_message !== null) {
        updatePdlConfigData({
          errorMessage: t('subscriptionTools:pdl_search.default_error_message'),
          isLoading: false,
          viewPage: 'results'
        })
        console.error(e.error_message)
        return
      }

      if (e.response.length > 0) {
        updateList(e.response)
      }

      updatePdlConfigData({ isLoading: false, viewPage: 'results' })
    })

    return () => {
      window.Echo.leaveChannel(`retrieve-search-pod-data.${podSearchDataId}`)
    }
  }, [podSearchDataId])

  return {
    searchPDLs,
    errorMessage,
  }
}

export default useRetrievePDLsV2
